import React from "react";
import { Link } from "react-router-dom";
import { Car, ArrowLeft } from "lucide-react";

const TermeniConditii = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white border-b border-gray-100 py-4">
        <div className="max-w-4xl mx-auto px-4 flex items-center gap-4">
          <Link to="/" className="flex items-center gap-2" data-testid="terms-logo">
            <div className="w-10 h-10 bg-emerald-500 rounded-xl flex items-center justify-center">
              <Car className="w-6 h-6 text-white" />
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-lg text-gray-900 leading-tight">AUTO PRO</span>
              <span className="text-xs text-emerald-600 font-medium -mt-1">DAUNE</span>
            </div>
          </Link>
          <Link to="/" className="ml-auto flex items-center gap-1 text-sm text-gray-500 hover:text-emerald-600" data-testid="terms-back">
            <ArrowLeft className="w-4 h-4" />Inapoi
          </Link>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-4 py-12" data-testid="terms-page">
        <h1 className="text-3xl font-bold text-gray-900 mb-8">Termeni si Conditii</h1>
        <p className="text-sm text-gray-400 mb-8">Ultima actualizare: Aprilie 2026</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">1. Informatii despre operator</h2>
            <p>Prezentul site web este operat de <strong>SC AUTO PRO DAUNE & ASIGURARI SRL</strong>, cu sediul social in Bucuresti, Romania.</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>CUI: <strong>49492739</strong></li>
              <li>Nr. Reg. Com.: <strong>J40/1769/2024</strong></li>
              <li>Email: <strong>office@autoprodaune.ro</strong></li>
              <li>Telefon: <strong>0725 399 235</strong></li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">2. Descrierea serviciilor</h2>
            <p>AutoPro Daune ofera servicii de consultanta si asistenta in procesul de obtinere a despagubirilor auto din polite RCA si CASCO. Serviciile noastre includ:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Analiza si evaluarea dosarelor de dauna</li>
              <li>Reprezentarea clientului in relatia cu asiguratorul</li>
              <li>Asistenta in documentatia necesara</li>
              <li>Negocierea despagubirilor cu companiile de asigurari</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">3. Acceptarea termenilor</h2>
            <p>Prin accesarea si utilizarea site-ului autoprodaune.ro, sunteti de acord cu prezentii Termeni si Conditii. Daca nu sunteti de acord cu oricare dintre acesti termeni, va rugam sa nu utilizati site-ul.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">4. Utilizarea site-ului</h2>
            <p>Site-ul poate fi utilizat de persoane fizice si juridice care doresc sa beneficieze de serviciile noastre de consultanta in domeniul despagubirilor auto. Utilizatorii trebuie sa furnizeze informatii corecte si complete la completarea formularelor.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">5. Programul de afiliere</h2>
            <p>AutoPro Daune ofera un program de afiliere prin care partenerii pot recomanda clienti. Afiliatul va primi un cod unic de recomandare si poate urmari statusul dosarelor recomandate prin portalul dedicat. Comisioanele sunt platite conform conditiilor stabilite individual.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">6. Limitarea raspunderii</h2>
            <p>AutoPro Daune ofera consultanta si asistenta in procesul de despagubire. <strong>Decizia finala de plata si suma aprobata depind exclusiv de asigurator si de conditiile politei RCA/CASCO.</strong> Nu garantam obtinerea unei anumite sume sau a unui rezultat specific.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">7. Proprietate intelectuala</h2>
            <p>Continutul site-ului (texte, imagini, grafice, logo) este proprietatea SC AUTO PRO DAUNE & ASIGURARI SRL si este protejat de legislatia privind drepturile de autor. Reproducerea fara acordul prealabil este interzisa.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">8. Protectia datelor</h2>
            <p>Prelucrarea datelor cu caracter personal se face in conformitate cu Regulamentul (UE) 2016/679 (GDPR). Pentru detalii, consultati <Link to="/politica-confidentialitate" className="text-emerald-600 hover:underline">Politica de Confidentialitate</Link>.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">9. Legea aplicabila</h2>
            <p>Prezentii Termeni si Conditii sunt guvernati de legislatia romana. Orice litigiu va fi solutionat de instantele competente din Bucuresti, Romania.</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mt-8 mb-3">10. Contact</h2>
            <p>Pentru orice intrebari referitoare la acesti Termeni si Conditii, ne puteti contacta la:</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>Email: office@autoprodaune.ro</li>
              <li>Telefon: 0725 399 235</li>
            </ul>
          </section>
        </div>
      </main>
    </div>
  );
};

export default TermeniConditii;
